import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {
	envAwareFormSubmit,
	envAwarePost
} from '../util/util'

export const getExerciseLibrary = createAsyncThunk(
	'getExerciseLibrary',
	async (_,{getState})=> {
		const state = getState()
		const account_type = state.users.current_user?.account_type
		const list_type = (
			account_type === 'client' ?
			//rely on server side to get correct list
			'default' :
			//else just get the trainer list
			'selfOnlyTrainer'
		)
		return await envAwarePost('api/events/api/',{
			action:'getExerciseList',
			list_type
		})
	}
)

export const getAdditionalExerciseData = createAsyncThunk(
	'getAdditionalExerciseData',
	async ()=> await envAwarePost('api/events/api/',{
		action:'getAdditionalExerciseData',
	})
)

export const createExercise = createAsyncThunk(
	'createExercise',
	async payload => {
		const postData = {
			action:'createExercise',
			muscle_group_id:payload.muscleGroupId,
			equipment_ids:payload.equipmentIds,
			level_id:payload.exerciseLevelId,
			preview:payload.preview,
			notes:payload.notes,
			name:payload.name,
			link:payload.link
		}
		return await envAwareFormSubmit({path:'api/exercises/api/',payload:postData})
	}
)

const adapter = createEntityAdapter()

const slice = createSlice({
	name: 'exercises',
	initialState:adapter.getInitialState({
		status:'init',
		filters:{
			status:'init'
		}
	}),
	reducers: {},
	extraReducers:{
		[getExerciseLibrary.pending] : state => { state.status = 'pending' },
		[getExerciseLibrary.fulfilled] : (state,action) => {
			state.status = 'loaded'
			const {data} = action.payload
			adapter.upsertMany(state,data)
		},
		[getAdditionalExerciseData.pending] : (state,action)=>{
			state.filters.status = 'pending'
		},
		[getAdditionalExerciseData.fulfilled] : (state,action)=>{
			const {muscle_groups,exercise_levels,equipment} = action.payload.data
			state.filters.status = 'loaded'
			state.filters.muscleGroups = muscle_groups
			state.filters.exerciseLevels = exercise_levels
			state.filters.equipment = equipment
		}
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllExercises,
	selectById: selectExerciseById,
	selectIds: selectExercisesIds
} = adapter.getSelectors(state => state.exerciseLibrary)


export default slice.reducer